let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3t6fF"), load("cBo2a")]).then(() => parcelRequire('7xxJX'));